
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button, ButtonGroup } from "@ronuse/norseu/core/buttons";
import { TabPanePage } from "./TabPanePage";
import { Scheme } from "@ronuse/norseu/core/variables";

export class AccordionPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
		this.onClick = this.onClick.bind(this);
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Accordion activeIndex={[2]}>
                                <AccordionPanel header="Title 1">
                                    {TabPanePage.text1()}
                                </AccordionPanel>
                                <AccordionPanel header="Title 2">
                                    {TabPanePage.text2()}
                                </AccordionPanel>
                                <AccordionPanel header="Title 3">
                                    {TabPanePage.text3()}
                                </AccordionPanel>
                            </Accordion>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Multiple With Schemes</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Accordion scheme={Scheme.PRIMARY} activeIndex={[2]} multiple>
                                <AccordionPanel scheme={Scheme.SUCCESS} header="Title 1">
                                    {TabPanePage.text1()}
                                </AccordionPanel>
                                <AccordionPanel scheme={Scheme.WARNING} header="Title 2">
                                    {TabPanePage.text2()}
                                </AccordionPanel>
                                <AccordionPanel scheme={Scheme.DANGER} header="Title 3">
                                    {TabPanePage.text3()}
                                </AccordionPanel>
                            </Accordion>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Skeleton</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Accordion scheme={Scheme.SKELETON} activeIndex={1}>
                                <AccordionPanel header="Title 1">
                                    {TabPanePage.text1()}
                                </AccordionPanel>
                                <AccordionPanel header="Title 2">
                                    {TabPanePage.text2()}
                                </AccordionPanel>
                                <AccordionPanel header="Title 3">
                                    {TabPanePage.text3()}
                                </AccordionPanel>
                            </Accordion>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Custom Logic and Header</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <ButtonGroup scheme={Scheme.SECONDARY} className="norseu-m-bottom-20px">
                                <Button icon={`fa fa-${this.state.activeIndex && this.state.activeIndex.indexOf(0) > -1 ? 'plus' : 'minus'}`} text="Toggle Panel 1" onClick={() => this.onClick(0)}/>
                                <Button icon={`fa fa-${this.state.activeIndex && this.state.activeIndex.indexOf(1) > -1 ? 'plus' : 'minus'}`} text="Toggle Panel 2" onClick={() => this.onClick(1)}/>
                                <Button icon={`fa fa-${this.state.activeIndex && this.state.activeIndex.indexOf(2) > -1 ? 'plus' : 'minus'}`} text="Toggle Panel 3" onClick={() => this.onClick(2)}/>
                            </ButtonGroup>
                            
                            <Accordion activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: [e.index] })}>
                                <AccordionPanel header={<React.Fragment><i className="fa fa-user-o norseu-m-right-5px"/>User</React.Fragment>}>
                                    {TabPanePage.text1()}
                                </AccordionPanel>
                                <AccordionPanel header={<React.Fragment><i className="fa fa-gear norseu-m-right-5px"/>Settings</React.Fragment>}>
                                    {TabPanePage.text2()}
                                </AccordionPanel>
                                <AccordionPanel header={<React.Fragment><i className="fa fa-search norseu-m-right-5px"/>Search Profiles<i className="fa fa-eye norseu-m-left-5px"/></React.Fragment>}>
                                    {TabPanePage.text3()}
                                </AccordionPanel>
                            </Accordion>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Accordion",
            import_statement: "import { Accordion } from '@ronuse/norseu/core/panels'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/panels/AccordionPage.js"
        });
    }

    state = {
        pageSource: '',
        activeIndex: null,
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
    ];

    onClick(panelIndex) {
        let activeIndex = this.state.activeIndex ? [...this.state.activeIndex] : [];
        if (activeIndex.length === 0) {
            activeIndex.push(panelIndex);
        } else {
            const index = activeIndex.indexOf(panelIndex);
            if (index === -1) {
                activeIndex.push(panelIndex);
            } else {
                activeIndex.splice(index, 1);
            }
        }
        this.setState({ activeIndex: activeIndex });
    }

}
